import { Select } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import SectionTitle from '../../../../components/text/SectionTitle';
import { useValidations } from '../../../../hooks/useValidations';
import {
  educationalLevelOptions,
  familyGroupOptions,
  parentalSurvivalOptions,
} from '../../../../utils/selectOptions';
import { FieldsStudentFile } from './StudentFileForm';

/**
 * Sección de Antecedentes educacionales de los padres
 */
const ParentalEducationSection = () => {
  const { control } = useFormContext<FieldsStudentFile>();
  const prefix = 'tuitionProcess.studentFile.parentalEducationSection';
  const { t } = useTranslation();
  const { msgValidations } = useValidations();
  return (
    <>
      <Row className="pt-5">
        <Col className="pb-3" xs={12}>
          <SectionTitle text={t(`${prefix}.title`)} />
        </Col>
        <Col className="pb-3" xs={12} lg={6}>
          <Select
            name="fatherEducationalLevel"
            label={t(`${prefix}.fatherEducationalLevel`)}
            options={educationalLevelOptions}
            isSearchable={false}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col className="pb-3" xs={12} lg={6}>
          <Select
            name="motherEducationalLevel"
            label={t(`${prefix}.motherEducationalLevel`)}
            options={educationalLevelOptions}
            isSearchable={false}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col className="pb-3" xs={12} lg={6}>
          <Select
            name="familyGroup"
            label={t(`${prefix}.familyGroup`)}
            options={familyGroupOptions}
            isSearchable={false}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col className="pb-3" xs={12} lg={6}>
          <Select
            name="parentalSurvival"
            label={t(`${prefix}.parentalSurvival`)}
            options={parentalSurvivalOptions}
            isSearchable={false}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
      </Row>
    </>
  );
};

export default ParentalEducationSection;
